import { API } from '../../../config'
import { errorHandler } from '../auth/errorAction'

export const unmountListJob = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DATA_JOB'})
}

export const unmountDetailJob = () => (dispatch) => {
  return dispatch({type: 'UNMOUNT_DETAIL_JOB'})
}

export const listJob = (params, successCB) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_JOB' })
  
  return API.GET('/job/list', params).then((response) => {
    dispatch({
      type: 'LOAD_DATA_JOB_SUCCESS', 
      payload: {
        data: response.data,
        meta: response.meta
    }})
    return successCB(params)
  }).catch((err) => {
    return dispatch(errorHandler(
      err.error || err.message, 
      dispatch({ type: 'LOAD_DATA_JOB_FAILED' }), 
    ))
  })
}

export const listJobCompany = (params) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DATA_JOB' })
  
  return API.GET('/job/list', params).then((response) => {
    dispatch({
      type: 'LOAD_DATA_JOB_SUCCESS', 
      payload: {
        data: response.data,
        meta: response.meta
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err.error || err.message, 
      dispatch({ type: 'LOAD_DATA_JOB_FAILED' }), 
    ))
  })
}

export const detailJob = (slug) => async (dispatch) => {
  await dispatch({ type: 'LOAD_DETAIL_JOB' })
  const params = {
    'slug': slug
  }
  return API.GET('/job/getBySlug', params).then((response) => {
    dispatch({
      type: 'LOAD_DETAIL_JOB_SUCCESS', 
      payload: {
        data: response.data
    }})
  }).catch((err) => {
    return dispatch(errorHandler(
      err.error || err.message, 
      dispatch({ type: 'LOAD_DETAIL_JOB_FAILED' }), 
    ))
  })
}